import { NameTypeEnum, SuffixEnum } from 'types/customer';

/* --------------- base/基础类型 --------------- */
export interface BaseRealNameInfoProps {
    disabled?: boolean;
}

/* --------------- 汇总类型 --------------- */

export interface RealNameInfoFormutil {
    name_type: NameTypeEnum;
    real_name: string;
    first_name: string;
    middle_initial: string;
    last_name: string;
    suffix: SuffixEnum;
}
